/**
 * Resolve Auth0 organization invitation params from a location-like object.
 *
 * Invitation emails land on `/login?invitation=…&organization=…`. Those values
 * must be passed to Auth0 `loginWithRedirect`; reading only Vue Router params is
 * racy because the global auth guard can hold navigation while Auth0 boots.
 *
 * @param {{ search?: string, query?: Record<string, string|string[]|null|undefined>, params?: Record<string, string|undefined> }} location
 *
 * @returns {{ organization: string|null, invitation: string|null }}
 */
export const resolveOrganizationInvitation = (location = {}) => {
  const fromSearch = new URLSearchParams(
    typeof location.search === 'string' ? location.search : '',
  )
  const query = location.query || {}
  const params = location.params || {}

  const pick = key => {
    const fromQuery = query[key]
    const queryValue = Array.isArray(fromQuery) ? fromQuery[0] : fromQuery

    return (
      params[key]
      || queryValue
      || fromSearch.get(key)
      || null
    )
  }

  return {
    organization: pick('organization'),
    invitation: pick('invitation'),
  }
}

export default resolveOrganizationInvitation
